import axios from 'axios';

const axiosInstance = axios.create({
  // baseURL: 'http://localhost:8080/api/v1'
  baseURL: 'https://plat-imee-backend.onrender.com/api/v1'
});

// Attach token to the Authorization header for each request
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token'); // Get token from localStorage
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;
